import $ from 'jquery'

export default class Share {
  static _shareEmail () {
    const pageUrl = encodeURIComponent(document.URL)
    $('.social-share.email').on('click', () => {
      const subject = encodeURIComponent($('meta[property=\'og:title\']').attr('content'))
      const url = `mailto:?Subject=${subject}&amp;Body=${pageUrl}`

      Share.socialWindow(url)
    })
  }

  static _shareTwitter () {
    const pageUrl = encodeURIComponent(document.URL)

    $('.social-share.twitter').on('click', () => {
      var tweet = encodeURIComponent($('meta[name=\'twitter:description\']').attr('content'))

      const url = `https://twitter.com/intent/tweet?url=${pageUrl}&text=${tweet}`
      Share.socialWindow(url)
    })
  }

  static _shareFacebook () {
    const pageUrl = encodeURIComponent(document.URL)

    $('.social-share.facebook').on('click', () => {
      const url = `https://www.facebook.com/sharer.php?u=${pageUrl}`
      Share.socialWindow(url)
    })
  }

  static socialWindow (url) {
    var left = (screen.width - 570) / 2
    var top = (screen.height - 570) / 2
    var params = `menubar=no,toolbar=no,status=no,width=570,height=570,top=${top},left=${left}`
    window.open(url, 'NewWindow', params)
  }

  static init () {
    if (document.querySelector('.vol_press_release_detail')) {
      Share._shareEmail()
      Share._shareTwitter()
      Share._shareFacebook()
    }
  }
}
